import { useMutation } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useError from 'hooks/useError';
import useSmartlook from 'hooks/useSmartlook';
import { postMessageToApp } from 'utils/postMessageToApp.ts';

function useAcceptUpsaleMutation() {
  const { error } = useSmartlook();
  const { showError } = useError();
  return useMutation<
    {
      rejected: boolean;
    },
    unknown,
    {
      amount: number;
    }
  >({
    mutationFn: async (payload) => {
      try {
        const resp = await fetchData('/client/application/upsale/accept', {
          method: 'post',
          body: JSON.stringify(payload),
        });
        postMessageToApp('upsale_accepted', payload);

        return resp;
      } catch (e) {
        error(
          '[useAcceptUpsaleMutation][POST /client/application/upsale/accept]',
          e,
        );
        showError();
        throw e;
      }
    },
  });
}

export default useAcceptUpsaleMutation;
